<template>
	<div class="bodyBox">
		<!-- 高级搜索 -->
		<div class="searchBox">
			<el-input placeholder="请输入名称" v-model="input" class="input-with-select" style=" width: 17%;">
				<el-button slot="append" icon="el-icon-search" type="primary" @click="inquire"></el-button>
			</el-input>
			<el-button type="primary" icon="el-icon-plus" @click="newAdd">新建商品码</el-button>
		</div>
		<!-- 表格 -->
		<section class="result-box">
			<el-table :data="tableData" style="width: 100%;min-height: 480px;">
				<el-table-column prop="name" label="名称" align="center">
					<template slot-scope="scope">
						<input v-show="scope.row.editor" class="edit-cell" v-model="scope.row.name" @blur="nameConfirm(scope.row)" />
						<span v-show="!scope.row.editor" @click="editName(scope.row)">{{ scope.row.name }}</span>
					</template>
				</el-table-column>
				<el-table-column label="封面" align="center">
					<template slot-scope="scope">
						<el-image v-if="scope.row.pic_name != ''" style="width: 100px; height: 100px" :src="scope.row.pic_name" fit="scale-down"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="content" label="内容" align="center">
					<template slot-scope="scope">
						<div v-html="scope.row.content"></div>
					</template>
				</el-table-column>
				<el-table-column prop="analynum_today" label="今日扫描次数" align="center"></el-table-column>
				<el-table-column prop="analynum_total" label="累计扫描次数" align="center"></el-table-column>
				<el-table-column prop="createtime" label="日期" align="center"></el-table-column>
				<el-table-column prop="address" label="操作" align="center" min-width="120px">
					<template slot-scope="scope">
						<el-button size="mini" plain type="primary" style="margin-top: 10px;margin-left: 0;margin-right: 10px;" @click="previewClick(scope.row)">预览</el-button>
						<el-button type="primary" plain size="mini" style="margin-top: 10px;margin-left: 0;margin-right: 10px;" @click="QRCode(scope.row)">二维码</el-button>
						<el-button type="primary" plain size="mini" style="margin-top: 10px;margin-left: 0;margin-right: 10px;" @click="edit(scope.row)">编辑</el-button>
						<el-button
							size="mini"
							v-if="scope.row.status == 1"
							type="primary"
							plain
							style="margin-top: 10px;margin-left: 0;margin-right: 10px;"
							@click="DisableBtn(scope.row)"
						>
							禁用
						</el-button>
						<el-button size="mini" v-else type="warning" plain style="margin-top: 10px;margin-left: 0;margin-right: 10px; " @click="DisableBtn(scope.row)">
							启用
						</el-button>
					</template>
				</el-table-column>
			</el-table>
		</section>
		<div class="pagination-box">
			<el-pagination
				background
				layout="prev, pager, next,slot,total,sizes"
				:total="pagination.total"
				:page-size="10"
				prev-text=" 上一页 "
				:page-sizes="[10, 20]"
				next-text="下一页"
				@prev-click="prev"
				@next-click="next"
				@current-change="currentChange"
				@size-change="sizeChange"
			></el-pagination>
		</div>
		<!-- 二维码弹窗 -->
		<el-dialog :visible.sync="dialogQR" width="360px">
			<div class="QRBox">
				<!-- <span style="text-align:center">二维码图片</span> -->
				<el-image style="width: 220px; height: 220px" :src="pirtuer.basUrl + pirtuer.imgUrl" fit="scale-down"></el-image>
			</div>
			<div>
				<h3 style="margin-left:-9px" class="mazhih3">选择码制</h3>
				<el-checkbox-group v-model="radioQR" @change="changeRadio">
					<el-checkbox :label="1">汉信码</el-checkbox>
					<el-checkbox :label="2">龙贝码</el-checkbox>
					<el-checkbox :label="3">GM码</el-checkbox>
					<el-checkbox :label="4">QR码</el-checkbox>
				</el-checkbox-group>
			</div>

			<div class="dalgSebox">
				<h3 style="margin-left:-9px">选择标码</h3>
				<el-select v-model="mark" placeholder="请选择" @change="markSelect">
					<el-option v-for="(item, index) in markOptions" :key="index" :label="item.identification" :value="item.identification_ID"></el-option>
				</el-select>
			</div>
			<el-button type="warning" @click="QRDownload" style="margin: 20px 0;">打包下载码图</el-button>
			<span slot="footer" class="dialog-footer"></span>
		</el-dialog>
		<!-- 预览弹窗 -->
		<el-dialog title="预览" custom-class="previewBoxs-box" :visible.sync="DisPreview" width="300px">
			<div class="previewBoxs">
				<!-- <p>{{ previewData.name }}</p>
				<img :src="previewData.cover" /> -->
				<div class="contentImg-box" v-html="previewData.content"></div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	name: 'GoodsCode',
	data() {
		return {
			options: [
				{
					value: '选项1',
					label: '普通码'
				},
				{
					value: '选项2',
					label: '标准码(MA.广联)'
				}
			],
			tableData: [
				// {
				// 	name: '酒品信息',
				// 	date: '2016-05-02',
				// 	cover: '78',
				// 	content: '酒品内容',
				// 	numberSCans: '酒品内容',
				// 	times: '酒品内容',
				// 	address: '上海市',
				// 	editor: false // 是否编辑
				// }
			],
			search: '',
			input: '',
			dialogQR: false, //  二维码弹窗
			radioQR: [4], // 二维码 默认汉信码
			DisPreview: false, // 预览弹窗
			previewData: {
				idcode: '',
				content: '',
				cover: '',
				name: ''
			}, // 预览数据
			QR: {
				identification: '', // 码标
				identification_ID: '' //  码标ID
			},
			mark: '', //标码
			markOptions: [], //标码选择列表
			idcode: '', // 唯一编码
			identificationID: '',
			pagination: {
				total: 0,
				page: 1,
				size: 10
			},
			api: '',
			pirtuer: {
				basUrl: '', // 图片地址(前半部分)
				imgUrl: '', // 图片名称(拼接路径后半部分)
				DM: '', // DM 码
				GM: '', // GM码
				QR: '', // QR码
				hanxin: '', // 汉信码
				longbei: '' // 龙背码
			},
			imgName: []
		};
	},
	computed: {},
	created() {
		this.api = 'http://192.168.1.118:8085/api/';
		this.context();
		this.QRq();
	},
	methods: {
		context() {
			this.$http
				.get(this.$api + '/lightapp/getProductCodeList', {
					params: {
						searchKeys: this.input,
						pageIndex: this.pagination.page,
						pageSize: this.pagination.size
					}
				})
				.then(
					res => {
						this.tableData = [];
						console.log('数据');
						console.log(res);
						if (res.data.hasOwnProperty('entity')) {
							res.data.entity.content.forEach(i => {
								i.editor = false; // 是否编辑
								this.tableData.push(i);
							});
							this.pagination.total = res.data.queryResult;
						}
					},
					rej => {}
				);
		},
		// 获取码标列表
		QRq() {
			this.$http.get(this.$api + '/lightapp/getIdentificationList', {}).then(
				res => {
					console.log('获取码标列表');
					console.log(res);
					this.markOptions = [];
					if (res.body.hasOwnProperty('entity')) {
						this.markOptions = res.body.entity;
						if (res.body.entity.length != 0) {
							this.mark = res.body.entity[0].identification_ID;
							this.identificationID = res.body.entity[0].identification_ID;
							if (this.idcode) {
								this.QRPictuer(this.idcode);
							}
						}
					}
				},
				rej => {}
			);
		},
		//  新增
		newAdd() {
			this.$router.push({ path: '/GoodsCodeAdd', query: {} });
		},
		//  禁用/启用
		DisableBtn(row) {
			this.$http
				.post(this.$api + '/lightapp/lightAppIsEnable', {
					id: row.id, // 名片id
					isEnable: row.status == 1 ? 0 : 1 // 1启用 0禁用
				})
				.then(
					res => {
						if (res.body.result == 1) {
							this.$message({
								message: row.status == 1 ? '禁用成功' : '启用成功',
								type: 'success'
							});
							this.context();
						}
					},
					rej => {}
				);
		},
		// 下载二维码
		QRDownload() {
			if (this.imgName.length == 0) {
				this.$message({
					message: '请选择码标',
					type: 'warning'
				});
				return;
			}
			// window.location.href = '/CommonMethod/ZipDownloadsBatch?fileNames=' + this.imgName.toString() + '&filePath=CreateCode';
			location.href = this.$api + '/CommonMethod/ZipDownloadsBatch/?fileNames=' + this.imgName.toString() + '&filePath=CreateCode';
		},
		// 二维码Radio事件
		changeRadio() {
			this.imgName = [];
			// console.log('二维码Radio事件');
			if (this.radioQR.indexOf(1) != -1) {
				// this.pirtuer.imgUrl = this.pirtuer.hanxin;
				this.imgName.push(this.pirtuer.hanxin);
			} else {
				var i = this.imgName.indexOf(this.pirtuer.hanxin);
				if (i != -1) {
					this.imgName.splice(i, 1);
				}
			}
			if (this.radioQR.indexOf(2) != -1) {
				// this.pirtuer.imgUrl = this.pirtuer.longbei;
				this.imgName.push(this.pirtuer.longbei);
			} else {
				var i = this.imgName.indexOf(this.pirtuer.longbei);
				if (i != -1) {
					this.imgName.splice(i, 1);
				}
			}
			if (this.radioQR.indexOf(3) != -1) {
				// this.pirtuer.imgUrl = this.pirtuer.GM;
				this.imgName.push(this.pirtuer.GM);
			} else {
				var i = this.imgName.indexOf(this.pirtuer.GM);
				if (i != -1) {
					this.imgName.splice(i, 1);
				}
			}
			if (this.radioQR.indexOf(4) != -1) {
				// this.pirtuer.imgUrl = this.pirtuer.QR;
				this.imgName.push(this.pirtuer.QR);
				// console.log(4)
				// console.log(this.pirtuer.QR)
			} else {
				var i = this.imgName.indexOf(this.pirtuer.QR);
				if (i != -1) {
					this.imgName.splice(i, 1);
				}
			}
			console.log(this.imgName)
			this.$forceUpdate();
		},
		// 码标选择
		markSelect() {
			this.imgName = [];
			this.QRCode();
		},
		// 搜索框搜索
		inquire() {
			this.pagination.page = 1;
			this.context();
		},
		// 预览
		previewClick(row) {
			this.$http
				.get(this.$api + '/lightapp/getLightAppByIdcode', {
					params: {
						idcode: row.idcode
					}
				})
				.then(
					res => {
						this.DisPreview = true;
						if (res.data.hasOwnProperty('entity')) {
							for (let k in res.data.entity) {
								let val = res.data.entity[k];
								if (this.previewData.hasOwnProperty(k)) {
									this.previewData[k] = val;
								}
								if (typeof val == 'object') {
									for (let key in val) {
										if (typeof val == 'object') {
											for (let v in val[key]) {
												if (this.previewData.hasOwnProperty(v)) {
													this.previewData[v] = val[key][v];
												}
											}
										}
									}
								}
							}
						}
					},
					rej => {}
				);
		},
		// 二维码
		QRCode(row) {
			this.imgName = [];
			this.radioQR = [4];
			this.dialogQR = true;
			this.idcode = row.idcode;
			this.$http
				.get(this.$api + '/CodeImage/createCodeImage', {
					params: {
						idcode: row.idcode, // 唯一编码
						identificationID: this.mark // 码标ID
					}
				})
				.then(
					res => {
						// console.log(res, '二维码图');
						// console.log(res.body.entity, '二维码图555');
						if (res.body.result === 1) {
							this.pirtuer.basUrl = res.body.entity.baseUrl; // 图片地址
							this.pirtuer.DM = res.body.entity.imgList.DM码; // DM 码
							this.pirtuer.GM = res.body.entity.imgList.GM码; // GM码
							this.pirtuer.QR = res.body.entity.imgList.QR码; // QR码
							this.pirtuer.hanxin = res.body.entity.imgList.汉信码; // 汉信码
							this.pirtuer.longbei = res.body.entity.imgList.龙贝码; // 龙背码
							this.pirtuer.imgUrl = this.pirtuer.QR;
							this.changeRadio();
						}
					},
					rej => {}
				);
		},
		// 编辑名称
		editName(row) {
			row.editor = true;
			this.$forceUpdate();
		},
		// 名称编辑确认
		nameConfirm(row) {
			this.$http
				.post(this.$api + '/lightapp/editProductCodeName', {
					id: row.id, /// 名片id
					name: row.name // 标题
				})
				.then(
					res => {
						row.editor = false;
						this.$forceUpdate();
					},
					rej => {}
				);
		},
		// 编辑
		edit(row) {
			this.$router.push({
				path: '/GoodsCodeEdit',
				query: { idcode: row.idcode, template_id: row.template_id, tabimgurl: row.pic_name, content: row.content, name: row.name, judedit: '1' }
			});
		},
		prev(val) {
			this.pagination.page = val;
			this.context();
		},
		next(val) {
			this.pagination.page = val;
			this.context();
		},
		currentChange(val) {
			this.pagination.page = val;
			this.context();
		},
		sizeChange(val) {
			this.pagination.page = 1;
			this.context();
		}
	}
};
</script>
<style lang="scss">
.bodyBox {
	width: auto !important;
	margin-top: 50px;
}
.input-with-select {
	width: 17%;
	margin-left: 30px;
	margin-right: 15px;
}

.searchBox {
	display: flex;
	flex-direction: row;
	flex-shrink: 1;
	margin-bottom: 40px;
}
.enterBox {
	.el-table__body-wrapper {
		min-height: 480px;
	}
}
.QRBox {
	margin: 0 auto;
	display: flex;
	height: 280px;
	border-bottom: 1px solid #e1e1e1;
	margin-bottom: 15px;
	justify-content: center; /* 水平居中 */
	align-items: center; /* 垂直居中 */
}
.el-dialog__body {
	padding: 30px 0px 30px 0px !important;
}
.dalgSebox {
	margin-top: 16px;
	margin-bottom: 10px;
}
.dalgSebox h3 {
	text-align: center;
	font-size: 16px;
	font-weight: normal;
	margin: 14px 0;
}
.mazhih3 {
	text-align: center;
	font-size: 16px;
	font-weight: normal;
	margin: 14px 0;
}

.pagination-box {
	margin-top: 50px;
}

// 预览弹窗
.previewBoxs-box {
	.previewBoxs {
		.contentImg-box {
			img {
				width: 250px;
				min-width: 200px;
				height: auto;
				object-fit: scale-down;
				margin: 0 auto;
			}
		}
	}
}
</style>
